<template>
  <ServicePageLayout
    title="Asset"
    subtitle="รายการทรัพย์สิน"
    icon="mdi-toy-brick-outline"
    breadcrumb="Assets"
  >
    <v-card flat class="service-content-panel">
      <v-card-text><ASSET_TABLE /></v-card-text>
    </v-card>
  </ServicePageLayout>
</template>

<script>
import ServicePageLayout from '@/components/layout/ServicePageLayout.vue'
import ASSET_TABLE from '@/components/asset/asset_table'

export default {
  name: 'AssetView',
  components: {
    ServicePageLayout,
    ASSET_TABLE
  },
}
</script>
